/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/destructuring-assignment */
import { ActionIcon, Button, Group, Modal, Paper, SimpleGrid, Space, Tooltip } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useState } from 'react';
import { showNotification } from '@mantine/notifications';
import PageViewProperty from '../../../../../../components/core/PageViewProperty/PageViewProperty';
import { EventDocumentType } from '../../../../../../models/core/events.type';
import eventsService from '../../../../../../services/core/events.service';
import theme from '../../../../../../theme';
import useCurrentUser from '../../../../../../hooks/useCurrentUser';
import { validate } from '../../../../../../utils/permission.utils';
import { Permission } from '../../../../../../models/core/departments.type';

type DataViewActionProps = {
  item: EventDocumentType;
  confirmActionResult(item: EventDocumentType | null, action: string, confirmed: boolean): void;
  zIndex: number;
};

type ModalData = {
  opened: boolean;
  action: string;
};

export default function DocumentFormViewActions(props: DataViewActionProps) {
  const [currentUser] = useCurrentUser();
  const [modalData, setModalData] = useState<ModalData>({ opened: false, action: '' });
  const [saving, setSaving] = useState(false);

  return (
    <div>
      <Modal
        opened={modalData.opened}
        closeOnClickOutside={false}
        closeOnEscape={false}
        size="xl"
        // centered={true}
        onClose={() => setModalData({ opened: false, action: '' })}
        title={`Gostaria de ${modalData.action} esse documento?`}
        zIndex={props.zIndex + 1}
      >
        <div>
          <Paper shadow="xs" p="md" withBorder>
            <SimpleGrid cols={4}>
              <PageViewProperty label="Tipo" text={props.item.documentoTipo} size="sm" />
              <PageViewProperty label="Outro tipo" text={`${props.item.outroTipo || '-'}`} size="sm" />
            </SimpleGrid>
            <Space h="xs" />
          </Paper>
          <Space h="lg" />

          <Group justify="right">
            <Button
              color="secondary"
              // leftSection={<IconArrowBackUp size={18} />}
              onClick={() => {
                setModalData({ opened: false, action: '' });
                props.confirmActionResult(props.item, modalData.action, false);
              }}
            >
              Não
            </Button>
            <Button
              // color={modalData?.action === 'cancelar' ? 'orange' : 'red'}
              // leftSection={<IconCheck size={18} />}
              color="primary"
              onClick={async () => {
                try {
                  setSaving(true);

                  await eventsService.deleteDocument({
                    idEvento: props.item!.idEvento,
                    idEventoDocumento: props.item!.idEventoDocumento!,
                  });

                  showNotification({
                    title: `Evento - Visualizar`,
                    message: `Documento excluído com sucesso.`,
                    color: 'green',
                  });

                  setModalData({ opened: false, action: '' });
                  props.confirmActionResult(props.item, modalData.action, true);
                } catch (exception: any) {
                  showNotification({
                    title: `Evento - Visualizar`,
                    message: exception?.isBusinessException
                      ? exception.description
                      : 'Não foi possível excluir o documento ao evento.',
                    color: 'red',
                  });
                } finally {
                  setSaving(false);
                }
              }}
              loading={saving}
            >
              Sim
            </Button>
          </Group>
        </div>
      </Modal>

      <Group>
        {validate(Permission.EventEdit, currentUser.permissoes) && (
          <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Editar">
            <ActionIcon
              size="sm"
              color="primary"
              style={{ borderColor: theme?.colors?.accent?.[6] }}
              variant="outline"
              onClick={() => {
                props.confirmActionResult(props.item, 'editar', true);
              }}
            >
              <IconEdit size={15} color={theme?.colors?.accent?.[6]} />
            </ActionIcon>
          </Tooltip>
        )}
        {validate(Permission.EventEdit, currentUser.permissoes) && (
          <Tooltip withArrow transitionProps={{ transition: 'fade', duration: 200 }} label="Excluir">
            <ActionIcon
              size="sm"
              radius="sm"
              color="primary"
              style={{ borderColor: 'red' }}
              variant="outline"
              onClick={() => {
                setModalData({ opened: true, action: 'excluir' });
              }}
            >
              <IconTrash size={15} color="red" />
            </ActionIcon>
          </Tooltip>
        )}
      </Group>
    </div>
  );
}
